import React from 'react';
import { I18n as I } from 'react-redux-i18n';
import LookupsHelper from 'lib/LookupsHelper';
import {
  TooltipButton,
  TooltipLink,
  formatCurrencyRounded,
  PartyTypes,
  AuctionStatuses,
} from 'vdlib';

import Tooltip from 'antd/lib/tooltip';

import {
  FileTextOutlined,
  EditOutlined,
  ClockCircleOutlined,
  LikeOutlined,
  DislikeOutlined,
  FireOutlined,
} from '@ant-design/icons';

import moment from 'moment';
import 'moment/locale/el';

import { PhotosAntCellRenderer } from 'components/tables/datagrid-columns/PhotosCellRenderer';
import TimeCellRenderer from 'components/tables/datagrid-columns/TimeCellRenderer';
import { getMerchantBidAmount } from 'components/tables/datagrid-columns/AmountDiffCellRenderer';

import model from '../../static/img/model.png';
import modelTruck from '../../static/img/truck48.png';
import modelOther from '../../static/img/other48.png';
import modelMoto from '../../static/img/motocyrcle48.png';
import modelPickup from '../../static/img/pickup48.png';

const dateFormat = 'DD-MM-YYYY';

const imageStyle = {
  height: '48px',
  width: '48px',
  textAlign: 'center',
};

const getPartsColumns = () => [
  {
    title: I.t('PART_NUMBER'),
    key: 'PartNumber',
    dataIndex: 'PartNumber',
    width: 50,
    align: 'center',
  },
  {
    title: I.t('DESCRIPTION'),
    key: 'PartDescription',
    dataIndex: 'PartDescription',
    width: 200,
    align: 'center',
  },
  {
    title: I.t('PRICE'),
    key: 'PartPrice',
    dataIndex: 'PartPrice',
    width: 70,
    align: 'center',
  },
];

const getColumns = ({
  exportToPdfCarAuctionPDF,
  findBestOffer,
  insurances,
  onOfferClick,
  onPhotoClick,
  regions,
  setAuctionToAccept,
  user,
  columnDefsKey,
}) => [
  {
    title: I.t('SN'),
    key: 'ID',
    dataIndex: 'ID',
    width: 100,
    align: 'center',
    render: (text, record) => (
      <div>
        {record.IsOnlineAuction ? (
          <div class="ribbon">
            <a href="#">
              <FireOutlined style={{ fontSize: 14, verticalAlign: '0em' }} />
              LIVE
            </a>
          </div>
        ) : null}

        {record.ID}
      </div>
    ),
  },
  {
    title: <div style={{ textAlign: 'center' }}>{I.t('INSURANCE')}</div>,
    key: 'Ασφαλιστική',
    dataIndex: 'InsuranceID',
    width: 300,
    align: 'center',
    render: (text, record) => (
      <div style={{ textAlign: 'center' }}>
        <div>
          <span style={{ fontWeight: 600, textAlign: 'center' }}>
            {LookupsHelper.getDescription(insurances, record.InsuranceID)}
          </span>
        </div>
        <div>
          <span style={{ fontSize: 12, textAlign: 'center' }}>
            {record.ExpertUsername}
          </span>
        </div>
      </div>
    ),
  },
  {
    title: `${I.t('FOLDER_NO')} ${I.t('PLATE_NUMBER')}`,
    key: 'Φάκελος-Πινακίδα',
    align: 'center',
    width: 200,
    render: (text, record) => (
      <div>
        <div>
          <span style={{ fontWeight: 600 }}>{record.FolderNumber}</span>
        </div>
        <div>
          <span>{record.PlateNumber}</span>
        </div>
      </div>
    ),
  },
  {
    title: <div style={{ textAlign: 'center' }}>Τ.Οχήματος</div>,
    key: 'Όχημα',
    dataIndex: 'VehicleTypeID',
    width:
      columnDefsKey === `${PartyTypes.Operator}_${AuctionStatuses.Pending}` ||
      columnDefsKey ===
        `${PartyTypes.Admin_Insurance}_${AuctionStatuses.Pending}`
        ? 120
        : null,
    align: 'center',
    render: (text, record) => (
      <img
        style={imageStyle}
        src={
          record.VehicleTypeID && record.VehicleTypeID === 1
            ? model
            : record.VehicleTypeID && record.VehicleTypeID === 2
            ? modelTruck
            : record.VehicleTypeID && record.VehicleTypeID === 3
            ? modelMoto
            : record.VehicleTypeID && record.VehicleTypeID === 4
            ? modelPickup
            : modelOther
        }
        alt=""
      />
    ),
  },
  {
    title: I.t('CHARACTERISTICS'),
    key: 'Χαρακτηριστικά',
    align: 'center',
    width:
      columnDefsKey === `${PartyTypes.Operator}_${AuctionStatuses.Pending}` ||
      columnDefsKey ===
        `${PartyTypes.Admin_Insurance}_${AuctionStatuses.Pending}`
        ? null
        : 350,
    render: (text, record) => (
      <div>
        <div>
          <span style={{ fontWeight: 600 }}>
            {record.VehicleBrand} {record.VehicleModel}
          </span>
        </div>
        <div>
          <span>
            {record.VehicleEngineCapacity || '-'} {record.VehicleEngine}
          </span>
        </div>
      </div>
    ),
  },
  {
    title: <div style={{ textAlign: 'center' }}>{I.t('REGION')}</div>,
    key: 'Νομός',
    dataIndex: 'RegionID',
    width: 100,
    align: 'center',
    render: (text, record) =>
      LookupsHelper.getDescription(regions, record.RegionID),
  },
  {
    key: 'Από Αρχείο',
    width: 50,
    align: 'center',
    render: (text, record) =>
      record.IsFromFile ? (
        <Tooltip title="Από Αρχείο">
          <FileTextOutlined style={{ fontSize: 16 }} />
        </Tooltip>
      ) : (
        <Tooltip title="Καταχώρηση">
          <EditOutlined style={{ fontSize: 16 }} />
        </Tooltip>
      ),
  },
  {
    title: I.t('DATE_CREATION'),
    key: 'CreatedDate',
    dataIndex: 'CreatedDate',
    width: 120,
    align: 'center',
    render: (text, record) => (
      <span>{moment(record.CreatedDate).format(dateFormat)}</span>
    ),
  },
  {
    key: 'Λεπτομέρειες',
    width: 60,
    align: 'center',
    fixed: 'right',
    render: (text, record) => (
      <div className="cell-fix-wrap">
        <TooltipLink
          to={'/auctions/' + record.ID}
          className="blue action-button"
          icon="info-circle"
          text={I.t('MORE')}
        />
      </div>
    ),
  },
  {
    title: <div style={{ textAlign: 'center' }}>{I.t('PHOTOS')}</div>,
    key: 'Φωτογραφίες',
    width: 150,
    align: 'center',
    render: (text, record) => PhotosAntCellRenderer(record, onPhotoClick),
  },
  {
    title: I.t('MARKET_VALUE'),
    key: 'Εμπορική Αξία',
    dataIndex: 'MarketValue',
    width: 120,
    align: 'center',
    render: (text, record) => (
      <span>{formatCurrencyRounded(record.MarketValue)}</span>
    ),
  },
  {
    title: 'Best',
    key: 'Best',
    width: 100,
    align: 'center',
    render: (text, record) =>
      record.Bids.length === 0 ? (
        0
      ) : (
        <span style={{ fontSize: 16, fontWeight: 600, color: '#468847' }}>
          {formatCurrencyRounded(findBestOffer(record.Bids))}
        </span>
      ),
  },
  {
    title: I.t('END_DATE'),
    key: 'EndDate',
    dataIndex: 'EndDate',
    width: 120,
    align: 'center',
    fixed: 'right',
    defaultSortOrder: 'descend',
    sortDirections: ['descend', 'ascend'],
    sorter: (a, b) => a.EndDate - b.EndDate,
    render: (text, record) => (
      <div className="cell-fix-wrap">
        <span>{moment(record.EndDate).format(dateFormat)}</span>
      </div>
    ),
  },
  {
    title: I.t('REMAINING_TIME_SHORT'),
    key: 'Υπ. Χρόνος',
    dataIndex: 'EndDate',
    width: 130,
    align: 'center',
    fixed: 'right',
    defaultSortOrder: 'ascend',
    sortDirections: ['descend', 'ascend'],
    sorter: (a, b) => a.EndDate - b.EndDate,
    render: (text, record) => (
      <div className="cell-fix-wrap">
        <TimeCellRenderer
          value={moment(record.EndDate).toDate()}
          onlineMode={record.OnlineMode}
        />
      </div>
    ),
  },
  {
    key: 'Επιλογή',
    width: 100,
    align: 'center',
    fixed: 'right',
    render: (text, record) => (
      <div className="cell-fix-wrap">
        <TooltipButton
          onClick={e => exportToPdfCarAuctionPDF(record.ID)}
          className="green action-button"
          icon="print"
          text={I.t('PDF')}
        />
        <TooltipLink
          to={'/auctions/' + record.ID}
          className="blue action-button"
          icon="info-circle"
          text={I.t('MORE')}
          style={{ marginLeft: 2 }}
        />
      </div>
    ),
  },
  {
    title: I.t('OFFER'),
    key: 'Αποδεχθείσα Προσφορά',
    width: 100,
    align: 'center',
    render: (text, record) =>
      record.Bids.length === 0 ? (
        0
      ) : (
        <span style={{ fontSize: 16, fontWeight: 600, color: '#004E95' }}>
          {formatCurrencyRounded(record.Bids[0].Amount)}
        </span>
      ),
  },
  {
    title: I.t('OFFER'),
    key: 'InfoPDF',
    width: 100,
    align: 'center',
    fixed: 'right',
    render: (text, record) => (
      <div className="cell-fix-wrap">
        <TooltipLink
          to={'/auctions/' + record.ID}
          className="blue action-button"
          icon="info-circle"
          text={I.t('MORE')}
        />
        <TooltipButton
          onClick={e => exportToPdfCarAuctionPDF(record.ID)}
          className="green action-button"
          icon="print"
          text={I.t('PDF')}
          style={{ marginLeft: 2 }}
        />
      </div>
    ),
  },
  {
    title: I.t('OFFER'),
    key: 'Προσφορά Εμπόρου',
    width: 100,
    align: 'center',
    fixed: 'right',
    render: (text, record) => {
      const myBid =
        user &&
        record.Bids &&
        record.Bids.length > 0 &&
        record.Bids.find(b => b.BidderID === user.PartyId);
      return (
        <div className="cell-fix-wrap">
          <span style={{ fontSize: 16, fontWeight: 600, color: '#1d549b' }}>
            {myBid ? formatCurrencyRounded(myBid.Amount) : '-'}
          </span>
        </div>
      );
    },
  },
  {
    key: 'Προσφορά',
    width: 100,
    align: 'center',
    fixed: 'right',
    render: (text, record) => (
      <div className="cell-fix-wrap">
        <TooltipButton
          onClick={e => onOfferClick(record, e)}
          className="green action-button"
          icon="gavel"
          text={I.t('OFFER')}
        />
        <TooltipLink
          to={'/auctions/' + record.ID}
          className="blue action-button"
          icon="info-circle"
          text={I.t('MORE')}
          style={{ marginLeft: 2 }}
        />
      </div>
    ),
  },
  {
    key: 'Αποτέλεσμα',
    width: 100,
    align: 'center',
    render: (text, record) =>
      record.MaxOffer == null ? (
        <Tooltip title={I.t('PENDING')}>
          <ClockCircleOutlined style={{ color: '#3598DC', fontSize: 16 }} />
        </Tooltip>
      ) : record.MaxOffer ? (
        <Tooltip title={I.t('BEST_OFFER')}>
          <LikeOutlined style={{ color: 'green', fontSize: 16 }} />
        </Tooltip>
      ) : (
        <Tooltip title={I.t('NO_BEST_OFFER')}>
          <DislikeOutlined style={{ color: 'red', fontSize: 16 }} />
        </Tooltip>
      ),
  },
  {
    title: I.t('REASON'),
    key: 'Reason',
    dataIndex: 'Reason',
    width: 100,
    align: 'center',
  },
  {
    key: 'Αποδοχή',
    width: 100,
    align: 'center',
    fixed: 'right',
    render: (text, record) => (
      <div className="cell-fix-wrap">
        <TooltipButton
          onClick={() => setAuctionToAccept(record)}
          className="green action-button"
          icon="check-square"
          text={I.t('ACCEPTANCE')}
        />
        <TooltipLink
          to={'/auctions/' + record.ID}
          className="blue action-button"
          icon="info-circle"
          text={I.t('MORE')}
          style={{ marginLeft: 2 }}
        />
      </div>
    ),
  },
];

export { getColumns, getPartsColumns };
